<template>
  <div class="device-detail-sheet-daily">
    <div class="box">
      <!-- 过滤 -->
      <div class="query-filter">
        <div class="select-date">
          <h1>{{ $t('dds_day_ri_qi') }}</h1>
          <div style="margin-bottom: 16px">
            <custom-date-picker
              :clearable="false"
              v-model="selectDate"
              :init-value="initValue"
              value-format="YYYY-MM-DD HH:mm:ss"
              style="width: 150px"
              @init="refreshPage"
              @change="refreshPage"
              :picker-options="beforeToday"
            ></custom-date-picker>
          </div>
          <div class="tab-box" style="height: 40px">
            <el-tabs v-model="workClass" :key="1">
              <el-tab-pane v-for="item in tabData" :label="item.name" :name="item.value" :key="item.value"></el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="usage">
          <div class="usage-hours">
            <div class="usage-icon">
              <i>
                <img src="~@/images/layout/icon_day.png" alt />
              </i>
            </div>
            <ul class="log">
              <li class="line">
                <div class="bg">
                  <template v-for="(item, index) in filterWorkClass(line1)">
                    <template v-if="item.workTime">
                      <el-popover placement="top-start" trigger="hover" :key="index">
                        <div
                          slot="reference"
                          :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                          class="log"
                          style="height: 14px; position: absolute"
                          :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                        ></div>
                        <div class="popover-content">
                          <template>
                            <p v-if="item.workTime && `${item.workClass}` === '1'">{{ $t('dds_day_cdsc') }}: {{ $formatSecToHm(item.workTime) }}</p>
                            <p v-if="item.workTime && `${item.workClass}` !== '1'">{{ $t('dds_day_sysc') }}: {{ $formatSecToHm(item.workTime) }}</p>
                          </template>
                        </div>
                      </el-popover>
                    </template>
                    <template v-else>
                      <div
                        :key="index"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                        class="log"
                        style="height: 14px; position: absolute"
                        :style="{
                          width: (item.p2 - item.p1) * 100 + '%',
                          left: item.p1 * 100 + '%',
                        }"
                      ></div>
                    </template>
                  </template>
                </div>
                <div class="lable-box">
                  <!-- <i v-for="item in 7" :key="item">{{ item + 5 }}</i> -->
                  <i v-for="item in line1Lable" :key="item">{{ item }}</i>
                </div>
              </li>
              <li class="line">
                <div class="bg">
                  <template v-for="(item, index) in filterWorkClass(line2)">
                    <template v-if="item.workTime">
                      <el-popover placement="top-start" trigger="hover" :key="index">
                        <div
                          slot="reference"
                          :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                          style="height: 14px; position: absolute"
                          class="log"
                          :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                        ></div>
                        <div class="popover-content">
                          <template>
                            <p v-if="item.workTime && `${item.workClass}` === '1'">{{ $t('dds_day_cdsc_1') }}: {{ $formatSecToHm(item.workTime) }}</p>
                            <p v-if="item.workTime && `${item.workClass}` !== '1'">{{ $t('dds_day_sysc_1') }}: {{ $formatSecToHm(item.workTime) }}</p>
                          </template>
                        </div>
                      </el-popover>
                    </template>
                    <template v-else>
                      <div
                        :key="index"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                        style="height: 14px; position: absolute"
                        class="log"
                        :style="{
                          width: (item.p2 - item.p1) * 100 + '%',
                          left: item.p1 * 100 + '%',
                        }"
                      ></div>
                    </template>
                  </template>
                </div>
                <div class="lable-box">
                  <!-- <i v-for="item in 7" :key="item">{{ item + 11 }}</i> -->
                  <i v-for="item in line2Lable" :key="item">{{ item }}</i>
                </div>
              </li>
            </ul>
          </div>
          <div class="usage-hours">
            <div class="usage-icon">
              <i>
                <img src="~@/images/layout/icon_night.png" alt />
              </i>
            </div>
            <ul class="log">
              <li class="line">
                <div class="bg">
                  <template v-for="(item, index) in filterWorkClass(line3)">
                    <template v-if="item.workTime">
                      <el-popover placement="top-start" trigger="hover" :key="index">
                        <div
                          slot="reference"
                          :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                          class="log"
                          style="height: 14px; position: absolute"
                          :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                        ></div>
                        <div class="popover-content">
                          <template>
                            <p v-if="item.workTime && `${item.workClass}` === '1'">{{ $t('dds_day_cdsc_2') }}: {{ $formatSecToHm(item.workTime) }}</p>
                            <p v-if="item.workTime && `${item.workClass}` !== '1'">{{ $t('dds_day_sysc_2') }}: {{ $formatSecToHm(item.workTime) }}</p>
                          </template>
                        </div>
                      </el-popover>
                    </template>
                    <template v-else>
                      <div
                        :key="index"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                        class="log"
                        style="height: 14px; position: absolute"
                        :style="{
                          width: (item.p2 - item.p1) * 100 + '%',
                          left: item.p1 * 100 + '%',
                        }"
                      ></div>
                    </template>
                  </template>
                </div>
                <div class="lable-box">
                  <!-- <i v-for="item in 7" :key="item">{{
                item + 17 > 24 ? item + 17 - 24 : item + 17
              }}</i> -->
                  <i v-for="item in line3Lable" :key="item">{{ item }}</i>
                </div>
              </li>
              <li class="line">
                <div class="bg">
                  <template v-for="(item, index) in filterWorkClass(line4)">
                    <template v-if="item.workTime">
                      <el-popover placement="top-start" trigger="hover" :key="index">
                        <div
                          slot="reference"
                          class="log"
                          :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                          style="height: 14px; position: absolute"
                          :style="{ width: (item.p2 - item.p1) * 100 + '%', left: item.p1 * 100 + '%' }"
                        ></div>
                        <div class="popover-content" v-if="item.workTime">
                          <template>
                            <p v-if="item.workTime && `${item.workClass}` === '1'">{{ $t('dds_day_cdsc_3') }}: {{ $formatSecToHm(item.workTime) }}</p>
                            <p v-if="item.workTime && `${item.workClass}` !== '1'">{{ $t('dds_day_sysc_3') }}: {{ $formatSecToHm(item.workTime) }}</p>
                          </template>
                        </div>
                      </el-popover>
                    </template>
                    <template v-else>
                      <div
                        :key="index"
                        :class="{ charge: `${item.workClass}` === '1', manual: `${item.workClass}` === '2', auto: `${item.workClass}` === '5', train: `${item.workClass}` === '4' }"
                        style="height: 14px; position: absolute"
                        :style="{
                          width: (item.p2 - item.p1) * 100 + '%',
                          left: item.p1 * 100 + '%',
                        }"
                      ></div>
                    </template>
                  </template>
                </div>
                <div class="lable-box">
                  <!-- <i v-for="item in 7" :key="item">{{ item - 1 }}</i> -->
                  <i v-for="item in line4Lable" :key="item">{{ item }}</i>
                </div>
              </li>
            </ul>
          </div>
          <div class="usage-introduction">
            <div class="introduction-right">
              <div class="manual" v-if="isManual">
                <i></i>
                {{ iot_tsl_use_type2['2'] }}
              </div>
              <div class="auto" v-if="isAutonomous">
                <i></i>
                {{ iot_tsl_use_type2['5'] }}
              </div>
              <div class="train" v-if="isTraining">
                <i></i>
                {{ iot_tsl_use_type2['4'] }}
              </div>
              <div class="charge" v-if="isCharging">
                <i></i>
                {{ iot_tsl_use_type2['1'] }}
              </div>
            </div>
          </div>
          <div class="sheet-info box">
            <ul class="box">
              <!-- 全部 -->
              <template v-if="`${workClass}` === '0'">
                <li class="item">
                  <p class="mode">{{ $t('dds_day_qjsc') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.totalUsageTime === 0 ? '-' : $formatSecToHm(info.totalUsageTime) }}</p>
                    </li>
                  </ul>
                </li>
                <li class="item">
                  <p class="mode">{{ $t('dds_day_qing_jie_mian_ji') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.totalCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.totalCleanArea)) }}</p>
                    </li>
                  </ul>
                </li>
                <li class="item">
                  <p class="mode">{{ $t('dds_day_qing_jie_ci_shu') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.totalUsageCount || '-' }}</p>
                    </li>
                  </ul>
                </li>
                <li class="item" v-if="isAutonomous">
                  <p class="mode">{{ $t('dds_day_xie_zhu_ci_shu') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.assistCount || '-' }}</p>
                    </li>
                  </ul>
                </li>
              </template>
              <!-- 手工-->
              <template v-if="isManual && `${workClass}` === '2'">
                <li class="item">
                  <p class="mode">{{ $t('dds_day_sgqjsj') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                    </li>
                  </ul>
                </li>
                <li class="item">
                  <p class="mode">{{ $t('dds_day_sgqjmj') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.manualCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.manualCleanArea)) }}</p>
                    </li>
                  </ul>
                </li>
              </template>
              <!-- 智能清洁-->
              <template v-if="isAutonomous && `${workClass}` === '5'">
                <li class="item">
                  <p class="mode">{{ $t('dds_day_znqjsj') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                    </li>
                  </ul>
                </li>
                <li class="item">
                  <p class="mode">{{ $t('dds_day_znqjmj') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.autonomousCleanArea)) }}</p>
                    </li>
                  </ul>
                </li>
                <li class="item">
                  <p class="mode">{{ $t('dds_day_fu_zhu_ci_shu') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.assistCount }}</p>
                    </li>
                  </ul>
                </li>
              </template>
              <!-- 教学 -->
              <template v-if="isTraining && `${workClass}` === '4'">
                <li class="item">
                  <p class="mode">{{ $t('dds_day_jxqjsc') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                    </li>
                  </ul>
                </li>
                <li class="item">
                  <p class="mode">{{ $t('dds_day_jxqjmj') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.trainingCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.trainingCleanArea)) }}</p>
                    </li>
                  </ul>
                </li>
              </template>
              <!-- 充电-->
              <!-- v-if="isCharging && `${workClass}` === '1'" -->
              <template v-if="`${workClass}` === '0' || `${workClass}` === '1'">
                <li class="item">
                  <p class="mode">{{ $t('dds_day_cdsc_4') }}</p>
                  <ul>
                    <li class="param">
                      <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这个页面特殊  查询记录存在今天6点到明天6点的时间  传值要传本地6点的时间  转换成世界时间前一天10点
import moment from 'moment';
import apis from '@/utils/apis';

// dds_day_ri_qi: 日期// dds_day_cdsc: 充电时长// dds_day_sysc: 使用时长// dds_day_cdsc_1: 充电时长// dds_day_sysc_1: 使用时长// dds_day_cdsc_2: 充电时长// dds_day_sysc_2: 使用时长// dds_day_cdsc_3: 充电时长// dds_day_sysc_3: 使用时长// dds_day_qjsc: 清洁时长// dds_day_qing_jie_mian_ji: 清洁面积// dds_day_qing_jie_ci_shu: 清洁次数// dds_day_xie_zhu_ci_shu: 协助次数// dds_day_sgqjsj: 手工清洁时间// dds_day_sgqjmj: 手工清洁面积// dds_day_znqjsj: 智能清洁时间// dds_day_znqjmj: 智能清洁面积// dds_day_fu_zhu_ci_shu: 辅助次数// dds_day_jxqjsc: 教学清洁时长// dds_day_jxqjmj: 教学清洁面积// dds_day_cdsc_4: 充电时长

export default {
  name: 'day',
  props: {
    deviceInfo: [Object],
    tabData: [Array],
    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
    productClass: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    // dayTips() {
    //   return this.$formatTpl('报表由{{area}}({{utc}}) {{dayStartTime }}  到{{dayEndTime }}机器上传的数据生成', {
    //     area: this.area,
    //     utc: this.timeZone,
    //     dayStartTime: this.tipsDayStartTime,
    //     dayEndTime: this.tipsDayEndTime,,
    //   });
    // },
    line1Lable() {
      if (this.deviceInfo.localReportOffset === 6) {
        return [6, 7, 8, 9, 10, 11, 12];
      } else {
        return Array.from(new Array(7).keys());
      }
    },
    line2Lable() {
      if (this.deviceInfo.localReportOffset === 6) {
        return [12, 13, 14, 15, 16, 17, 18];
      } else {
        return [6, 7, 8, 9, 10, 11, 12];
      }
    },
    line3Lable() {
      if (this.deviceInfo.localReportOffset === 6) {
        return [18, 19, 20, 21, 22, 23, 24];
      } else {
        return [12, 13, 14, 15, 16, 17, 18];
      }
    },
    line4Lable() {
      if (this.deviceInfo.localReportOffset === 6) {
        return Array.from(new Array(7).keys());
      } else {
        return [18, 19, 20, 21, 22, 23, 24];
      }
    },
  },
  data() {
    return {
      selectDate: '',
      workClass: '0',
      formSearch: {
        // bodyNum: '0002190500067',
        // startTime : '2020-06-12 00:00:00',
        // endTime : '2020-06-12 23:59:59'
        bodyNum: this.deviceInfo.bodyNum,
        startTime: this.startTime,
        endTime: this.endTime,
      },
      initValue: '',
      beforeToday: {},
      dayList: [],
      // totalRows: null,
      info: {
        // 总
        totalCleanArea: '', // 总清洁面积
        totalUsageCount: '', // 总清洁次数
        totalUsageTime: '', // 总清洁时长
        // 手工
        manualUsageTime: '',
        manualCleanArea: '',
        // 智能
        autonomousUsageTime: '',
        autonomousCleanArea: '',
        // 教学
        trainingCleanArea: '',
        trainingUsageTime: '',
        assistCount: '',
        // 充电
        chargingTime: '',
      },
      scheduleList: [],

      line1: [],
      line2: [],
      line3: [],
      line4: [],

      iot_tsl_use_type2: {},
      // 提示开始区间
      tipsDayStartTime: '',
      tipsDayEndTime: '',
      area: '',

      workClassList: [],
    };
  },
  watch: {
    'deviceInfo.bodyNum': {
      immediate: true,
      handler(val) {
        if (val) {
          // 已到期设备用已到期的时候
          this.initValue = this.deviceInfo.unbindOrgTime
            ? `${this.$moment(this.deviceInfo.unbindOrgTime, 'YYYY-MM-DD 00:00:00')}`
            : `${this.$moment(this.$getLocalTime()).format('YYYY-MM-DD')} 00:00:00`;
          const beforeTime = this.deviceInfo.unbindOrgTime ? this.deviceInfo.unbindOrgTime : this.$getLocalTime();
          this.beforeToday = {
            disabledDate: time => moment(time).isAfter(beforeTime, 'day'),
          };
          this.refreshPage();
        }
      },
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_device_detail_sheet_day');
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // this.refreshPage();
    this.getDictionary('iot_tsl_use_type2', (data) => {
      this.iot_tsl_use_type2 = this.$transformDicValue(data.iot_tsl_use_type2);
    });
  },
  methods: {
    // 获取今日详情
    getSheetInfo: function () {
      // this.formSearch.startTime = moment(this.selectDate).format('YYYY-MM-DD');
      // this.formSearch.endTime = moment(this.selectDate).format('YYYY-MM-DD');

      // this.formSearch.startTime = this.$moment.utc(this.selectDate).format('YYYY-MM-DD HH:mm:ss');
      // this.formSearch.endTime = this.$moment.utc(this.selectDate).add(1, 'd').format('YYYY-MM-DD HH:mm:ss');
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      this.$getJSON(apis.DeviceReportDaily, this.formSearch).then((res) => {
        if (res.data && Object.keys(res.data).length !== 0) {
          // this.info = res.data;
          this.$setFormatData(this.info, res.data);
        } else {
          // 总
          this.info.totalCleanArea = 0;
          this.info.totalUsageCount = 0;
          this.info.totalUsageTime = 0;
          // 手工
          this.info.manualUsageTime = 0;
          this.info.manualCleanArea = 0;
          // 智能
          this.info.autonomousUsageTime = 0;
          this.info.autonomousCleanArea = 0;
          // 智能

          this.info.trainingUsageTime = 0;
          this.info.trainingCleanArea = 0;
          this.info.assistCount = 0;
          // 充电
          this.info.chargingTime = 0;
        }
      });
    },
    setWorkClasseList: function () {
      // "1": "充电", "2": "清洁", "4": "教学", "5": "自动"
      this.workClassList = [];
      if (this.isCharging) {
        this.workClassList.push('1');
      }
      if (this.isManual) {
        this.workClassList.push('2');
      }
      if (this.isAutonomous) {
        this.workClassList.push('5');
      }
      if (this.isTraining) {
        this.workClassList.push('4');
      }
    },
    // 获取今日详情
    getSheetDayInfo: function () {
      // this.formSearch.startTime = this.$moment.utc(this.selectDate).format('YYYY-MM-DD HH:mm:ss');
      // this.formSearch.endTime = this.$moment.utc(this.selectDate).add(1, 'd').format('YYYY-MM-DD HH:mm:ss');

      // 后端修改后替换
      // this.formSearch.startTime = this.$moment.utc(this.selectDate).format('YYYY-MM-DD HH:mm:ss');
      // this.formSearch.endTime = this.$moment.utc(this.selectDate).add(1, 'd').subtract(1, 's').format('YYYY-MM-DD HH:mm:ss');
      this.$getJSON(apis.deviceReportDailyWorkRunList, this.formSearch).then((res) => {
        // this.dayList = res.data || [];
        const data = res.data || [];
        // 如果是充电模式
        data.forEach((i) => {
          if (i.workClass === '1') {
            i.siteName = '-';
            i.hlcCode = '-';
            i.slotCode = '-';
            i.cleanedArea = '-';
            i.workTime = '-';
            i.runLength = '-';
            i.assistCount = '-';
          }
        });
        this.nullValueToCrossbar(data, ['assistCount']);
        this.setWorkClasseList();
        // data.push({
        //   bodyNum: '60101004674',
        //   cleanedArea: 38.304,
        //   dayReportId: '670676164251041722',
        //   // endTime: '2021-12-20 01:49:32',
        //   id: '61c04b5b137fcb0006c23b62',
        //   locationId: '657658339617202176',
        //   locationName: 'i20NBL项目2021年冬季',
        //   productCode: 'i20NBL',
        //   recordTime: '2021-12-20 01:49:32',
        //   runLength: 75.396,
        //   siteAddress: '',
        //   siteId: '657658339617202177',
        //   siteName: '',
        //   startTime: '2021-12-19 01:44:06',
        //   uploadTime: '2021-12-20 09:22:34',
        //   workClass: 2,
        //   workTime: 32226
        // });
        const filterData = data.filter(item => this.workClassList.includes(`${item.workClass}`) && !!item.endTime && item.workTime > 0);
        // 记录的世界时间转本地时间
        filterData.forEach((i) => {
          i.startTime = this.$momentElLocal(i.startTime);
          i.endTime = this.$momentElLocal(i.endTime);
        });
        this.dayList = filterData;
        // 1是ICe 2是sbr Whiz deviceInfo.productBrand==='ICE'"
        // "1": "充电", "2": "清洁", "4": "教学", "5": "自动"
        // this.scheduleList = this.dayList.filter(item => `${item.workClass}` === '1' || `${item.workClass}` === '2' || `${item.workClass}` === '4' || `${item.workClass}` === '5');
        this.scheduleList = this.dayList;
        this.scheduleList.forEach((item) => {
          item.progress = this.progressSet(item);
        });
        this.line1 = [];
        this.line2 = [];
        this.line3 = [];
        this.line4 = [];
        // 第一行  (6-12点 选第二段line=2)
        this.line1 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 1);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
        // 第二行  (12-18点 选第二段line=3)
        this.line2 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 2);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
        // 第三行  (18-24点 选第二段line=4)
        this.line3 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 3);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
        // 第四行  (0-6点 选第二段line=1)
        this.line4 = this.scheduleList
          .map((oldItem) => {
            let newItem = {};
            newItem = { ...oldItem };
            newItem.progress = null;
            const progress1 = oldItem.progress.filter(ptem => ptem.line === 4);
            progress1.forEach((pItem) => {
              newItem.line = pItem.line;
              newItem.p1 = pItem.p1;
              newItem.p2 = pItem.p2;
            });
            return newItem;
          })
          .filter(item => !!item.line);
      });
    },
    // 获取今日报表时间区间
    getDailyTime: function () {
      this.$getJSON(apis.DeviceReportDailyTime, {
        bodyNum: this.deviceInfo.bodyNum,
        date: this.$momentElLocal(this.selectDate, 'YYYY-MM-DD'),
      }).then((res) => {
        this.tipsDayStartTime = res.data.startTime;
        this.tipsDayEndTime = res.data.endTime;
        this.area = this.getDicValue('bas_hq_timeZone', `${res.data.timeZoneValue}`);
        //
        // this.formSearch.startTime = this.$momentWorld(res.data.startTime);
        // this.formSearch.endTime = this.$momentWorld(res.data.endTime);
        this.formSearch.startTime = res.data.reportStartTime;
        this.formSearch.endTime = res.data.reportEndTime;
        this.getSheetDayInfo();
        this.getSheetInfo();
      });
    },
    // 时间进度条长度
    progressSet: function (time) {
      const result = [];
      const allSeconds = 6 * 60 * 60 * 4;
      let startPoint = '';
      if (this.deviceInfo.localReportOffset === 6) {
        // 中国时区 6-6
        startPoint = moment(this.$momentElLocal(this.selectDate, 'YYYY-MM-DD 05:59:59')).unix();
      } else {
        // 世界时间 0-0
        startPoint = moment(this.$momentElLocal(this.selectDate, 'YYYY-MM-DD 23:59:59')).subtract(1, 'days').unix();
      }
      // const endPoint = moment(moment(moment(time.endTime).add(1, 'days')).format('YYYY-MM-DD 06:00:00')).unix();
      const p = {
        p1: (moment(time.startTime).unix() - startPoint) / allSeconds, // 开始点的百分数占四条线总长度的百分比
        p2: (moment(time.endTime).unix() - startPoint) / allSeconds, // 结束点的百分数占四条线总长度的百分比
      };
      // 出现跨天设置为一天后面都铺满
      if (p.p2 > 1) {
        p.p2 = 1;
      }
      // 如果开始事件超出
      if (p.p1 > 1) {
        return result;
      }
      const arr = [0, 0.25, 0.5, 0.75, 1];
      const lineIndexStart = arr.findIndex((item, index) => p.p1 > item && p.p1 <= arr[index + 1]) + 1;
      const lineIndexEnd = arr.findIndex((item, index) => p.p2 > item && p.p2 <= arr[index + 1]) + 1;
      const point = {
        x1: 0, // 开始点占当前线段的百分比
        x2: 0, // 结束点占当前线段的百分比
      };
      switch (lineIndexStart) {
        case 1:
          point.x1 = p.p1 / 0.25;
          break;
        case 2:
          point.x1 = (p.p1 - 0.25) / 0.25;
          break;
        case 3:
          point.x1 = (p.p1 - 0.5) / 0.25;
          break;
        case 4:
          point.x1 = (p.p1 - 0.75) / 0.25;
          break;
      }
      switch (lineIndexEnd) {
        case 1:
          point.x2 = p.p2 / 0.25;
          break;
        case 2:
          point.x2 = (p.p2 - 0.25) / 0.25;
          break;
        case 3:
          point.x2 = (p.p2 - 0.5) / 0.25;
          break;
        case 4:
          point.x2 = (p.p2 - 0.75) / 0.25;
          break;
      }

      // console.log('开始点在第' + lineIndexStart + '条线上')
      // console.log('结束点在第' + lineIndexEnd + '条线上')

      if (lineIndexStart === lineIndexEnd) {
        // 如果一直都是同一个状态
        result.push({
          line: lineIndexStart,
          p1: point.x1,
          p2: point.x2,
        });
      } else {
        result.push({
          line: lineIndexStart,
          p1: point.x1,
          p2: 1,
        });

        for (let index = lineIndexStart + 1; index < lineIndexEnd; index++) {
          result.push({
            line: index,
            p1: 0,
            p2: 1,
          });
        }

        result.push({
          line: lineIndexEnd,
          p1: 0,
          p2: point.x2,
        });
      }
      return result;
    },

    // 刷新
    refreshPage: function () {
      if (this.selectDate && this.deviceInfo.bodyNum) {
        this.formSearch.bodyNum = this.deviceInfo.bodyNum;
        this.getDailyTime();
      }
    },

    // 类型
    filterWorkClass(list) {
      if (this.workClass === '0') {
        return list;
      }
      return list.filter(i => `${i.workClass}` === `${this.workClass}`);
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-sheet-daily {
  .select-date {
    h1 {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: $--color-primary;
      margin-bottom: 4px;
    }
    .el-input__prefix {
      color: $--color-primary;
      font-size: 18px;
      margin-right: 8px;
    }
    .el-input .el-input__inner {
      cursor: pointer;
      height: 40px;
      line-height: 41px;
      padding-left: 34px;
      font-weight: bold;
      color: $--color-text-primary;
    }
    .el-input__suffix {
      margin-right: 30px;
      .el-input__icon:after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        color: $--color-warning;
        margin-bottom: 2px;
      }
    }
  }
  .el-tabs .el-tabs__item {
    font-size: 14px;
  }
  .title {
    padding-left: 10px;
    background: rgba(53, 184, 224, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: #6c757d;
    .icon {
      color: RGBA(13, 154, 224, 1);
      margin-right: 10px;
    }
  }
  .usage {
    background-color: #fff;
    border-radius: 16px;
    padding: 32px 24px 24px 24px;
    margin-top: 24px;
    .usage-introduction {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        height: 17px;
        font-size: 12px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 17px;
      }
      .introduction-right {
        margin-bottom: 24px;
        display: flex;
        justify-content: center;
        div {
          i {
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-right: 4px;
            line-height: 32px;
            border-radius: 50%;
          }
          padding: 0 12px;
          margin-right: 8px;
          height: 32px;
          font-size: 12px;
          font-weight: bold;
          color: $--color-text-regular;
          line-height: 32px;
          display: flex;
          align-items: center;
        }
        div:last-child {
          margin-left: 0;
        }
        .charge {
          i {
            background-color: $--color-warning;
          }
        }
        .manual {
          i {
            background-color: $--color-success;
          }
        }
        .auto {
          i {
            background-color: $--color-primary;
          }
        }
        .train {
          i {
            background-color: $--color-text-primary;
          }
        }
      }
    }
    .usage-hours {
      display: flex;
      padding: 24px 24px 24px 24px;
      margin-bottom: 24px;
      .usage-icon {
        i {
          display: inline-block;
          margin-right: 48px;
          width: 44px;
          height: 44px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      // margin-top: 12px;
      .log {
        flex: 1;
        // padding-right: 12px;
        .line {
          width: 100%;
          margin-top: 16px;
          .bg {
            background-color: #f5f5f5;
            height: 14px;
            width: 100%;
            position: relative;
            border-radius: 100px;
            .log {
              border-radius: 100px;
            }
            .charge {
              background-color: $--color-warning;
            }
            .manual {
              background-color: $--color-success;
            }
            .auto {
              background-color: $--color-primary;
            }
            .train {
              background-color: $--color-text-primary;
            }
          }
          .lable-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 23px;
            margin: 0 -10px; //超出边边
            i {
              width: 20px;
              height: 20px;
              font-size: 12px;
              font-weight: bold;
              margin-top: 3px;
              color: #818181;
              line-height: 20px;
              text-align: center;
              position: relative;
              &:before {
                height: 6px;
                width: 1px;
                background-color: rgba(0, 0, 0, 0.1);
                // text-align: right;
                content: '';
                display: block;
                position: absolute;
                top: -3px;
                left: 50%;
              }
              &:last-of-type:before {
                position: absolute;
                top: 0;
                right: 0;
              }
            }
          }
          &:nth-child(1) {
            margin-top: 0px;
          }
        }
      }
    }
  }
  .sheet-info {
    padding: 24px 24px 24px 0;
    .box {
      padding: 0 16px;
      display: flex;
      li.item {
        border-right: 1px solid #e9ebec;
        margin-left: 32px;
        width: 150px;
        &:first-child {
          margin: 0;
        }
        .mode {
          font-size: 12px;
          font-weight: bold;
          color: $--color-text-secondary;
          line-height: 17px;
        }
        ul {
          display: flex;
          margin-top: 4px;
          .param {
            padding-right: 32px;
            // h2 {
            //   height: 17px;
            //   font-size: 12px;
            //   color: rgba(152, 166, 173, 1);
            //   line-height: 17px;
            //   margin-bottom: 5px;
            // }
            p {
              height: 25px;
              font-size: 18px;
              font-weight: bold;
              color: $--color-text-primary;
              line-height: 25px;
            }
          }
        }

        &:last-of-type {
          border: none;
        }
      }
    }
    .time {
      color: #0d9ae0;
    }
    .box-bottom {
      margin-top: 16px;
      text-align: right;
      height: 17px;
      font-size: 12px;
      color: #6c757d;
      line-height: 17px;
    }
  }
}
</style>
